import {
  CHECK_CALLS_STATUS,
  CHECK_FOR_NEW_AVAILABLE_VERSION,
  CHECK_NOTIFICATIONS,
  ERROR_FETCHING_BOOKINGS,
  ERROR_FETCHING_HISTORIC_SERVICES,
  ERROR_FETCHING_LIVE_SERVICES,
  FETCH_BOOKINGS,
  FETCH_HISTORIC_TRIPS,
  FETCH_LIVE_SERVICES,
  NEW_VERSION_AVAILABLE,
  UPDATE_BOOKING_SERVICES,
  UPDATE_CALLS_STATUS,
  UPDATE_HISTORIC_SERVICES,
  UPDATE_LIVE_SERVICES,
  UPDATE_NOTIFICATIONS,
} from "@/events/constants";
import ApiPbxClient from "@/api/ApiPbxClient";
import ApiClient from "@/api/ApiClient.ts";
import qs from "qs";
import { uniq } from "lodash";
import semver from "semver";

const store = window.store;

self.name = "SCHEDULED-WORKER";

let currentManifest = null;

let latestVersionOnInit = null;

async function handleFetchLiveServices() {
  const idWg = uniq(
    store.getters["app/selectedWorkgroupsAndCentrals"].map((item) => item.wgId).filter((v) => v)
  );
  if (idWg.length > 0) {
    const idCentral = uniq(
      store.getters["app/selectedWorkgroupsAndCentrals"]
        .map((item) => item.centralId)
        .filter((v) => v)
    );
    const params = {
      idWg: JSON.stringify(idWg),
      idCentral: idCentral.length > 0 ? JSON.stringify(idCentral) : null,
    };
    try {
      const services = await new ApiClient()
        .get(
          `trips/live?${qs.stringify(params, {
            skipNulls: true,
            encode: false,
          })}`
        )
        .then((res) => res.data);
      window.$bus.emit(UPDATE_LIVE_SERVICES, services);
    } catch (err) {
      window.$bus.emit(ERROR_FETCHING_LIVE_SERVICES, {
        error: err,
        errorResponse: err.response?.data,
        errorCode: err.response?.status,
      });
    }
  }
}

async function handleFetchBookings() {
  const idWg = uniq(
    store.getters["app/selectedWorkgroupsAndCentrals"].map((item) => item.wgId).filter((v) => v)
  );
  if (idWg.length > 0) {
    const idCentral = uniq(
      store.getters["app/selectedWorkgroupsAndCentrals"]
        .map((item) => item.centralId)
        .filter((v) => v)
    );
    const params = {
      idWg: JSON.stringify(idWg),
      idCentral: idCentral.length > 0 ? JSON.stringify(idCentral) : null,
      mode: "scheduledHome",
    };
    try {
      const bookings = await new ApiClient()
        .get(
          `services/services2?${qs.stringify(params, {
            skipNulls: true,
            encode: false,
          })}`
        )
        .then((res) => res.data);
      window.$bus.emit(UPDATE_BOOKING_SERVICES, bookings);
    } catch (err) {
      window.$bus.emit(ERROR_FETCHING_BOOKINGS, {
        error: err,
        errorResponse: err.response?.data,
        errorCode: err.response?.status,
      });
    }
  }
}

async function handleFetchHistoricTrips() {
  const idWg = uniq(
    store.getters["app/selectedWorkgroupsAndCentrals"].map((item) => item.wgId).filter((v) => v)
  );
  if (idWg.length > 0) {
    const idCentral = uniq(
      store.getters["app/selectedWorkgroupsAndCentrals"]
        .map((item) => item.centralId)
        .filter((v) => v)
    );
    const params = {
      wgId: JSON.stringify(idWg),
      centralId: idCentral.length > 0 ? JSON.stringify(idCentral) : null,
      mode: "tripHistoricHome",
    };
    try {
      const historicServices = await new ApiClient()
        .get(
          `trips/historic2?${qs.stringify(params, {
            skipNulls: true,
            encode: false,
          })}`
        )
        .then((res) => res.data);
      window.$bus.emit(UPDATE_HISTORIC_SERVICES, historicServices);
    } catch (err) {
      window.$bus.emit(ERROR_FETCHING_HISTORIC_SERVICES, {
        error: err,
        errorResponse: err.response?.data,
        errorCode: err.response?.status,
      });
    }
  }
}

async function handleCheckoutIfUpdateIsAvailable() {
  try {
    const versions = (
      await fetch("https://panel-releases.2kbo.com/versions").then((res) => res.text())
    )
      .split("\n")
      .filter(Boolean)
      .map((v) => v.split(" ")[0].trim())
      .reverse();
    const latestVersion = versions[0].trim();
    if (latestVersionOnInit === null) {
      latestVersionOnInit = latestVersion;
    }
    if (semver.gt(latestVersion, latestVersionOnInit)) {
      window.$bus.emit(NEW_VERSION_AVAILABLE, { version: latestVersion });
    }
  } catch (e) {
    console.error("Error checking for new version", e);
  }
}

async function handleCheckNotifications() {
  if (!store.getters["operators/userHasManagementPermission"]) return;
  try {
    const params = {
      wgId: JSON.stringify(store.getters["app/selectedWorkgroupsAndCentrals"].map((sw) => sw.wgId)),
    };
    const queryString = qs.stringify(params, {
      skipNulls: true,
      encode: false,
    });
    const response = await new ApiClient()
      .get(`notifications?${queryString}`)
      .then((res) => res.data);
    window.$bus.emit(UPDATE_NOTIFICATIONS, response);
  } catch (e) {
    console.error(e);
  }
}

async function handleCheckCallsStatus() {
  if (!store?.getters["operators/userHasManagementPermission"]) return;
  if (!store?.getters["app/callCenter"]) return;
  try {
    const params = {
      // Some callcenters uses the wgIds while others uses the callCentersId. That's decided on the backend.
      wgId: JSON.stringify(store.getters["app/selectedWorkgroupsAndCentrals"].map((sw) => sw.wgId)),
      callcentersId: JSON.stringify([store.getters["app/callCenter"].id]),
    };
    const queryString = qs.stringify(params, {
      skipNulls: true,
      encode: false,
    });
    const response = await new ApiPbxClient()
      .get(`calls/status?${queryString}`)
      .then((res) => res.data);
    window.$bus.emit(UPDATE_CALLS_STATUS, response);
  } catch (e) {
    console.error(e);
  }
}

export default {
  async handle(event, payload) {
    switch (event) {
      case FETCH_LIVE_SERVICES:
        await handleFetchLiveServices(payload);
        break;
      case FETCH_BOOKINGS:
        await handleFetchBookings(payload);
        break;
      case FETCH_HISTORIC_TRIPS:
        await handleFetchHistoricTrips(payload);
        break;
      case CHECK_FOR_NEW_AVAILABLE_VERSION:
        await handleCheckoutIfUpdateIsAvailable();
        break;
      case CHECK_NOTIFICATIONS:
        handleCheckNotifications();
        break;
      case CHECK_CALLS_STATUS:
        handleCheckCallsStatus();
        break;
    }
  },
};
